export default __webpack_public_path__ + "static/media/5.226fc081.jpg";